import React from 'react';
import { Helmet } from 'react-helmet';
import Favicon16by16 from '../../assets/img/favicons/favicon-16x16.png';
import Favicon32by32 from '../../assets/img/favicons/favicon-32x32.png';
import Favicon96by96 from '../../assets/img/favicons/favicon-96x96.png';
import Favicon128by128 from '../../assets/img/favicons/favicon-128x128.png';
import Favicon196by196 from '../../assets/img/favicons/favicon-196x196.png';

const Head: React.FC<Helmet> = ({ title, description, keywords, metaRobotsIndex, children }) => {
  return (
    <Helmet>
      <meta charSet='utf-8' />
      <meta name='title' content={title} />
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />

      <meta property='og:type' content='website' />
      <meta property='og:url' content='https://classity.co' />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      {/* TODO: Add OG image */}
      <meta property='og:image' content={''} />

      <meta property='twitter:card' content='summary_large_image' />
      <meta property='twitter:url' content='https://classity.co' />
      <meta property='twitter:title' content={title} />
      <meta property='twitter:description' content={description} />
      {/* TODO: Add OG image */}
      <meta property='twitter:image' content={''} />

      {/* Block bot indexing */}
      {!metaRobotsIndex && <meta name='robots' content='noindex' />}
      {!metaRobotsIndex && <meta name='robots' content='noindex' />}

      <title>{title}</title>
      <link rel='icon' type='image/png' href={Favicon196by196} sizes='196x196' />
      <link rel='icon' type='image/png' href={Favicon96by96} sizes='96x96' />
      <link rel='icon' type='image/png' href={Favicon32by32} sizes='32x32' />
      <link rel='icon' type='image/png' href={Favicon16by16} sizes='16x16' />
      <link rel='icon' type='image/png' href={Favicon128by128} sizes='128x128' />
      {children}
    </Helmet>
  );
};

Head.defaultProps = {
  title: 'Premier online school in Nigeria | Classity',
  description:
    'National curriculum-backed online classes for primary to secondary school students, exam prep, JAMB, WAEC, and entrance exams. Delivered by qualified teachers.',
  keywords: 'Online classes and exam prep for primary to secondary school students.',
  metaRobotsIndex: true,
};

export default Head;
